import { render } from "./SolicitarGaraje.vue?vue&type=template&id=4f79cefd&scoped=true"
import script from "./SolicitarGaraje.vue?vue&type=script&lang=js"
export * from "./SolicitarGaraje.vue?vue&type=script&lang=js"

import "./SolicitarGaraje.vue?vue&type=style&index=0&id=4f79cefd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f79cefd"]])

export default __exports__